module.exports = __webpack_public_path__ + "static/media/turnLeft.41a1ba85.svg";